import SingleSearch from "./index.vue";

SingleSearch.install = Vue => Vue.component(SingleSearch.componentName, SingleSearch);

export default SingleSearch;
